/* CNOIR "Concierge" product page (2026-10-18). Asset file: the store's speed app blocks inline section scripts. */
(function () {
  var root = document.querySelector('[data-cnoir-concierge]');
  if (!root) return;
  var section = root.closest('section, .shopify-section') || document;
  var fitNote = root.getAttribute('data-fit') || '';

  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  var today = new Date(), dispatch = addBiz(today, 14);

  // 1. Dated timeline.
  section.querySelectorAll('[data-cnoir-tl]').forEach(function (el) {
    el.innerHTML =
      '<div><b>Today</b>' + fmt(today) + '</div>' +
      '<div><b>Made</b>10–14 business days</div>' +
      '<div><b>Dispatched</b>by ' + fmt(dispatch) + '</div>' +
      '<div><b>With you</b>UK ' + fmt(addBiz(dispatch, 2)) + '<br>Intl ' + fmt(addBiz(dispatch, 7)) + '</div>';
  });

  // 2. Christmas order-by line: counts down, gone after the UK date.
  section.querySelectorAll('[data-cnoir-xmas]').forEach(function (el) {
    var y = today.getFullYear();
    var intl = new Date(y, 10, 24, 23, 59), uk = new Date(y, 11, 1, 23, 59);
    var days = function (d) { return Math.ceil((d - today) / 864e5); };
    if (today > uk || today.getMonth() < 8) { el.remove(); return; }
    var t = el.querySelector('span');
    t.innerHTML = today <= intl
      ? 'For Christmas, order by <b>24 Nov</b> (international, ' + days(intl) + ' days left) or <b>1 Dec</b> (UK).'
      : 'For Christmas, order by <b>1 Dec</b> (UK, ' + days(uk) + ' days left).';
    el.hidden = false;
  });

  // 3. Size help per product type. Everything sits outside <variant-selects> so Dawn's re-render keeps it.
  var kind = root.getAttribute('data-kind') || 'apparel';
  function sizeSet() {
    var sets = section.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /^\s*(size|collar|waist)/i.test(lg.textContent)) return sets[i];
    }
    return null;
  }
  function radios(fs) { return Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]')); }
  function choose(value) {
    var fs = sizeSet(); if (!fs) return;
    var inp = radios(fs).find(function (x) { return x.value === value; });
    if (inp && !inp.checked) { var lab = fs.querySelector('label[for="' + inp.id + '"]'); (lab || inp).click(); }
  }
  var vs = section.querySelector('variant-selects');
  var fs0 = sizeSet();
  var EU = { 'UK 5': 'EU 39', 'UK 6': 'EU 40', 'UK 7': 'EU 41', 'UK 8': 'EU 42', 'UK 9': 'EU 43', 'UK 10': 'EU 44', 'UK 11': 'EU 45', 'UK 12': 'EU 46', 'UK 13': 'EU 47' };

  if (vs && fs0) {
    var values = radios(fs0).map(function (i) { return i.value; });
    var split = values.length && values.every(function (v) { return /\d+\s*[×x]\s*\d+/.test(v); });

    // 3a. Jeans sold as "30 × 32": two short rows (waist, leg) instead of one long list.
    if (split) {
      var parse = function (v) { var m = v.match(/(\d+)\s*[×x]\s*(\d+)/); return [m[1], m[2]]; };
      var W = [], L = [];
      values.forEach(function (v) { var p = parse(v); if (W.indexOf(p[0]) < 0) W.push(p[0]); if (L.indexOf(p[1]) < 0) L.push(p[1]); });
      var cur = values.find(function (v) { var i = radios(fs0).find(function (x) { return x.value === v; }); return i && i.checked; });
      var SW = { w: cur ? parse(cur)[0] : null, l: cur ? parse(cur)[1] : null };
      var wl = document.createElement('div'); wl.className = 'cnoir-cc-wl';
      var rowHtml = function (k, list, label, unit) {
        return '<div class="cnoir-cc-wl__l">' + label + '</div><div class="cnoir-cc-wl__r" data-k="' + k + '" style="--n:' + list.length + '">' +
          list.map(function (v) { return '<button type="button" data-v="' + v + '" aria-pressed="false">' + v + unit + '</button>'; }).join('') + '</div>';
      };
      wl.innerHTML = rowHtml('w', W, 'Waist', '"') + rowHtml('l', L, 'Leg <small>inside leg</small>', '"');
      var paint = function () {
        wl.querySelectorAll('[data-k="w"] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === SW.w)); });
        wl.querySelectorAll('[data-k="l"] button').forEach(function (b) {
          var v = b.getAttribute('data-v'); b.setAttribute('aria-pressed', String(v === SW.l));
          b.disabled = !!SW.w && values.indexOf(SW.w + ' × ' + v) < 0 && !values.some(function (x) { var p = parse(x); return p[0] === SW.w && p[1] === v; });
        });
      };
      wl.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        SW[b.parentNode.getAttribute('data-k')] = b.getAttribute('data-v'); paint();
        if (SW.w && SW.l) { var v = values.find(function (x) { var p = parse(x); return p[0] === SW.w && p[1] === SW.l; }); if (v) choose(v); }
      });
      vs.parentNode.insertBefore(wl, vs.nextSibling);
      var hideOrig = function () { var f = sizeSet(); if (f) f.classList.add('cnoir-cc-hide'); };
      hideOrig(); new MutationObserver(hideOrig).observe(vs, { childList: true, subtree: true });
      paint();
    }

    // 3b. Finder (collapsed): asks the one question that matters for this type.
    var cfg = {
      apparel: { sum: 'Not sure of your size? <u>Find my size</u>', q: 'Your usual size', pref: true },
      collar: { sum: 'Not sure of your collar? <u>Find my collar</u>', q: 'Your usual collar size', tip: 'Measure round your neck where the collar sits and add half an inch, or use the collar size of a shirt that fits you.' },
      uk: { sum: 'Not sure of your size? <u>Find my size</u>', q: 'Your usual UK shoe size', tip: 'Between sizes? Take the larger.' },
      waist: { sum: 'Not sure of your size? <u>Find my size</u>', q: 'Your usual trouser waist' },
      belt: { sum: 'Which belt size? <u>Find my size</u>', q: 'Your trouser waist', tip: 'Take your usual trouser waist size.' }
    }[kind];
    if (cfg && !split) {
      var S = { usual: null, pref: 'reg' };
      var box = document.createElement('details'); box.className = 'cnoir-cc-finder';
      box.innerHTML = '<summary class="cnoir-cc-finder__t">' + cfg.sum + '</summary>' +
        (cfg.tip ? '<p class="cnoir-cc-tip">' + cfg.tip + '</p>' : '') +
        '<div class="cnoir-cc-q"><span>' + cfg.q + '</span><div class="cnoir-cc-chips" data-q="usual">' +
        values.map(function (v) { return '<button type="button" data-v="' + v + '" aria-pressed="false">' + v + '</button>'; }).join('') + '</div></div>' +
        (cfg.pref ? '<div class="cnoir-cc-q"><span>How do you like it?</span><div class="cnoir-cc-chips" data-q="pref"><button type="button" data-v="reg" aria-pressed="true">As shown</button><button type="button" data-v="loose" aria-pressed="false">Looser</button></div></div>' : '') +
        '<p class="cnoir-cc-rec" aria-live="polite">Tap your usual size and we’ll pick one for you.</p>';
      vs.parentNode.insertBefore(box, vs);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        S[b.parentNode.getAttribute('data-q')] = b.getAttribute('data-v');
        b.parentNode.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (!S.usual) return;
        var i = values.indexOf(S.usual);
        var rec = values[Math.min(i + (S.pref === 'loose' ? 1 : 0), values.length - 1)];
        choose(rec);
        box.querySelector('.cnoir-cc-rec').innerHTML = 'We’d pick <b>' + rec + '</b>. It’s selected below.';
      });
    }

    // 3c. Size buttons in even rows; EU size under UK sizes.
    var mark = function () {
      var f = sizeSet(); if (!f) return;
      f.classList.add('cnoir-cc-sizes');
      var n = radios(f).length; f.style.setProperty('--n', n > 6 ? 4 : n);
      if (kind === 'uk') radios(f).forEach(function (inp) {
        var lab = f.querySelector('label[for="' + inp.id + '"]');
        if (lab && EU[inp.value] && !lab.querySelector('.cnoir-cc-eu')) { var s = document.createElement('small'); s.className = 'cnoir-cc-eu'; s.textContent = EU[inp.value]; lab.appendChild(s); }
      });
    };
    mark(); new MutationObserver(mark).observe(vs, { childList: true, subtree: true });
  }
  if (fitNote && vs) {
    var note = document.createElement('p'); note.className = 'cnoir-cc-fit'; note.textContent = fitNote.replace(/\s+/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); }) + '.';
    var after = section.querySelector('.cnoir-cc-wl') || vs;
    after.parentNode.insertBefore(note, after.nextSibling);
  }

  // 3d. Bags: a simple drawing of the size, with a phone for scale.
  var dims = (root.getAttribute('data-dims') || '').split('|').map(parseFloat);
  if (kind === 'none' && dims[0] > 0 && dims[1] > 0) {
    var L0 = dims[0], H0 = dims[1], D0 = dims[2] || 0, sc = 200 / Math.max(L0, H0 * 1.3), w = L0 * sc, h = H0 * sc, x = (260 - w) / 2;
    var pw = Math.min(7.1 * sc, w * 0.4), ph = Math.min(14.7 * sc, h * 0.8);
    var fig = document.createElement('figure'); fig.className = 'cnoir-cc-dims';
    fig.innerHTML = '<figcaption><span>Size</span><span>' + L0 + ' × ' + H0 + (D0 ? ' × ' + D0 : '') + ' cm</span></figcaption>' +
      '<svg viewBox="0 0 260 ' + Math.round(h + 46) + '" role="img" aria-label="' + L0 + ' cm wide, ' + H0 + ' cm high' + (D0 ? ', ' + D0 + ' cm deep' : '') + ', shown next to a phone">' +
      '<rect x="' + x + '" y="14" width="' + w + '" height="' + h + '" fill="none" stroke="#1A1A1A" stroke-width="1.4"/>' +
      '<line x1="' + x + '" y1="' + (h + 30) + '" x2="' + (x + w) + '" y2="' + (h + 30) + '" stroke="#6B6B6B"/>' +
      '<text x="130" y="' + (h + 44) + '" text-anchor="middle" font-size="11" fill="#404040">' + L0 + ' cm</text>' +
      '<text x="' + (x + w + 8) + '" y="' + (14 + h / 2) + '" font-size="11" fill="#404040">' + H0 + ' cm</text>' +
      '<rect x="' + (x + w * 0.08) + '" y="' + (14 + h * 0.18) + '" width="' + pw + '" height="' + ph + '" rx="3" fill="#F4F4F4" stroke="#CFCFCF"/>' +
      '<text x="' + (x + w * 0.08 + pw / 2) + '" y="' + (14 + h * 0.18 + ph / 2 + 4) + '" text-anchor="middle" font-size="9" fill="#6B6B6B">phone</text></svg>';
    var anchor = vs || section.querySelector('.product-form');
    if (anchor) anchor.parentNode.insertBefore(fig, vs ? vs.nextSibling : anchor);
  }

  // 3e. "£X with any suit" line for formal shoes sits under the price.
  var shoeLine = section.querySelector('.cnoir-cc-head + .cnoir-nf-shoeline, .cnoir-nf-shoeline');
  var priceEl = section.querySelector('.price');
  if (shoeLine && priceEl) { var pb = priceEl.closest('[id^="price-"], .product__info-container > *') || priceEl; pb.parentNode.insertBefore(shoeLine, pb.nextSibling); }

  // 4. Sticky buy bar once the real button scrolls out of view. It presses the real button.
  var realBtn = section.querySelector('.product-form__submit');
  if (realBtn && 'IntersectionObserver' in window) {
    var titleEl = section.querySelector('.product__title h1, .product__title .h1');
    var bar = document.createElement('div'); bar.className = 'cnoir-cc-bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="cnoir-cc-bar__in"><div class="cnoir-cc-bar__info"><b></b><span></span></div><button type="button" tabindex="-1"></button></div>';
    document.body.appendChild(bar);
    bar.querySelector('b').textContent = titleEl ? titleEl.textContent.trim() : document.title;
    var bbtn = bar.querySelector('button');
    var syncBar = function () {
      var pe = section.querySelector('.price .price-item--last, .price .price-item--regular');
      var picked = Array.prototype.map.call(section.querySelectorAll('variant-selects input[type=radio]:checked, variant-selects select'), function (x) { return x.value; }).join(' · ');
      bar.querySelector('span').textContent = [picked, pe ? pe.textContent.trim() : ''].filter(Boolean).join(' · ');
      var t = realBtn.querySelector('span') ? realBtn.querySelector('span').textContent.trim() : realBtn.textContent.trim();
      bbtn.textContent = t; bbtn.disabled = realBtn.disabled;
    };
    bbtn.addEventListener('click', function () { if (!realBtn.disabled) realBtn.click(); });
    new IntersectionObserver(function (es) { es.forEach(function (e) {
      var on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bbtn.tabIndex = on ? 0 : -1;
    }); }).observe(realBtn);
    syncBar();
    new MutationObserver(syncBar).observe(section, { subtree: true, childList: true, characterData: true });
  }
  // 5. The offers block has its own Christmas line; this page shows it near the price instead.
  function dropOfferXmas() {
    section.querySelectorAll('.cnoir-co__eyebrow').forEach(function (p) {
      if (!/christmas/i.test(p.textContent)) return;
      var next = p.nextElementSibling;
      if (next && next.classList.contains('cnoir-co__title')) next.remove();
      p.remove();
    });
  }
  dropOfferXmas();
})();
